/* ============================================================
   MANGOMICHI — shared section behaviour
   Scroll reveals · manifesto ignition · billboard power-on ·
   countdown · waveform · film placeholder.
   Re-runs safely on Shopify theme-editor section reloads.
   ============================================================ */
(() => {
  'use strict';

  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (root = document) => {
    /* ---------- waveform bars ---------- */
    root.querySelectorAll('[data-mm-wave]').forEach((wave) => {
      if (wave.dataset.mmReady) return;
      wave.dataset.mmReady = '1';
      const n = 28;
      for (let i = 0; i < n; i++) {
        const bar = document.createElement('i');
        bar.style.setProperty('--h', (0.22 + Math.random() * 0.78).toFixed(2));
        bar.style.setProperty('--dl', (Math.random() * 2.4).toFixed(2));
        wave.appendChild(bar);
      }
    });

    /* ---------- countdown ---------- */
    root.querySelectorAll('[data-mm-countdown]').forEach((el) => {
      if (el.dataset.mmReady) return;
      el.dataset.mmReady = '1';
      const target = new Date(el.dataset.mmCountdown).getTime();
      if (isNaN(target)) { el.textContent = ''; return; }
      const pad = (v) => String(v).padStart(2, '0');
      const tick = () => {
        const diff = target - Date.now();
        if (diff <= 0) { el.textContent = '● Out now'; clearInterval(id); return; }
        const d = Math.floor(diff / 864e5);
        const h = Math.floor(diff / 36e5) % 24;
        const m = Math.floor(diff / 6e4) % 60;
        const s = Math.floor(diff / 1e3) % 60;
        el.textContent = `T-minus ${pad(d)}d : ${pad(h)}h : ${pad(m)}m : ${pad(s)}s`;
      };
      const id = setInterval(tick, 1000);
      tick();
    });

    /* ---------- film placeholder ---------- */
    root.querySelectorAll('[data-mm-film-play]').forEach((btn) => {
      if (btn.dataset.mmReady) return;
      btn.dataset.mmReady = '1';
      btn.addEventListener('click', () => {
        const frame = btn.closest('[data-mm-film]');
        if (frame) frame.classList.add('is-msg');
      });
    });
  };

  /* ---------- scroll-driven state ----------
     A passive scroll listener, not rAF: rAF is throttled in
     background tabs and stops firing entirely in some contexts. */
  const scan = () => {
    const reveals = [...document.querySelectorAll('.mm-rv:not(.is-in)')];
    const maniLines = [...document.querySelectorAll('.mm-mani__line, .mm-vow__l, .mm-vow__final')];
    const boards = [...document.querySelectorAll('[data-mm-billboard]:not(.is-on)')];
    return { reveals, maniLines, boards };
  };

  let cache = scan();

  const run = () => {
    const h = innerHeight;

    for (let i = cache.reveals.length - 1; i >= 0; i--) {
      const el = cache.reveals[i];
      if (el.getBoundingClientRect().top < h * 0.92) {
        el.classList.add('is-in');
        cache.reveals.splice(i, 1);
      }
    }

    for (const line of cache.maniLines) {
      const top = line.getBoundingClientRect().top;
      if (top < h * 0.7) line.classList.add('is-lit');
      else if (top > h * 0.95) line.classList.remove('is-lit');
    }

    for (let i = cache.boards.length - 1; i >= 0; i--) {
      const bb = cache.boards[i];
      if (bb.getBoundingClientRect().top < h * 0.6) {
        bb.classList.add('is-on');
        cache.boards.splice(i, 1);
      }
    }
  };

  const boot = () => {
    init();
    cache = scan();
    if (RM) {
      cache.reveals.forEach((el) => el.classList.add('is-in'));
      cache.maniLines.forEach((el) => el.classList.add('is-lit'));
      cache.boards.forEach((el) => el.classList.add('is-on'));
      return;
    }
    run();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (!RM) {
    addEventListener('scroll', run, { passive: true });
    addEventListener('resize', run, { passive: true });
  }

  /* theme editor: sections are swapped in without a page load */
  document.addEventListener('shopify:section:load', (e) => {
    init(e.target);
    boot();
  });
})();
